// Credit Agreement classification status options.
// Verbatim strings from the lender-acknowledgement classifier — do not
// reword; staff-facing dropdown and backend classification must match
// exactly.
export const CRA_CLASSIFICATION_OPTIONS: string[] = [
  'Investigating Fixed Commission',
  'Investigating DCA Commission',
  'No Investigation as No Commission',
  'DCA Commission',
  // 21 Aug 2026: the concluded fixed-commission status. Already on 159k live
  // claims (written upstream) but was missing here, so the claim screen
  // couldn't select the second-commonest status in the data.
  'Fixed Commission',
];
